<template>
  <div class="components">
    <div
      class="el-input is-disabled"
      v-if="
        (parseInt(fullData.ruleGenerateType, 10) === 2 ||
          parseInt(fullData.ruleGenerateType, 10) === 3) &&
        fullData.codeRule.length > 0
      "
    >
      <input
        v-if="fullData.defaults === ''"
        type="text"
        class="el-input__inner"
        :placeholder="inputValue ? inputValue : '自动生成'"
        disabled
      />
      <div class="tips" v-else>
        {{ inputValue ? inputValue : fullData.defaults }}
      </div>
    </div>
    <div v-else>
      <el-input
        :disabled="disabled || fullData.disabled"
        v-if="parseInt(fullData.fieldType, 10) === 1"
        :class="{ 'is-disabled': disabled || fullData.disabled }"
        v-model="inputValue"
        placeholder="请输入"
      >
      </el-input>
      <el-input
        type="textarea"
        v-if="parseInt(fullData.fieldType, 10) === 2"
        :autosize="{ minRows: 2, maxRows: 4 }"
        placeholder="请输入内容"
        :disabled="disabled || fullData.disabled"
        v-model="inputValue"
      >
      </el-input>
      <div
        class="el-input"
        :class="{ 'is-disabled': disabled || fullData.disabled }"
        v-if="parseInt(fullData.fieldType, 10) === 3"
      >
        <input
          class="el-input__inner"
          :class="{ 'with-suffix': fullData.suffix && fullData.suffix !== '' }"
          v-model="inputValue"
          @blur="checkValue"
          :disabled="disabled || fullData.disabled"
          placeholder="请输入"
        />
        <div
          class="el-input-group__append"
          v-if="fullData.suffix && fullData.suffix !== ''"
        >
          {{
            parseInt(fullData.suffix, 10) === 1 ||
            parseInt(fullData.suffix, 10) === 2
              ? parseInt(fullData.suffix, 10) === 1
                ? '元'
                : parseInt(fullData.suffix, 10) === 2
                ? '万元'
                : fullData.suffix
              : fullData.suffix
          }}
        </div>
      </div>
      <div
        class="el-input"
        :class="{ 'is-disabled': disabled || fullData.disabled }"
        v-if="parseInt(fullData.fieldType, 10) === 4"
      >
        <input
          class="el-input__inner"
          placeholder="请输入"
          :class="{ 'with-suffix': fullData.suffix && fullData.suffix !== '' }"
          v-model="inputValue"
          @blur="checkValue"
          :disabled="disabled || fullData.disabled"
        />
        <div
          class="el-input-group__append"
          v-if="fullData.suffix && fullData.suffix !== ''"
        >
          {{
            parseInt(fullData.suffix, 10) === 1 ||
            parseInt(fullData.suffix) === 2
              ? parseInt(fullData.suffix, 10) === 1
                ? '元'
                : parseInt(fullData.suffix, 10) === 2
                ? '万元'
                : fullData.suffix
              : fullData.suffix
          }}
        </div>
      </div>
      <!-- 单选 -->
      <el-select
        ref="select"
        class="el-select-info"
        v-model="singleId"
        @change="changeSingle"
        @visible-change="visibleChange"
        :disabled="disabled || fullData.disabled"
        v-if="parseInt(fullData.fieldType, 10) === 5"
      >
        <el-option
          v-for="(item, index) in singleList"
          :key="index"
          :value="item.id"
          :label="item.name"
        >
          {{ item.name }}
        </el-option>
      </el-select>
      <!-- 时间日期选择器 -->
      <div v-if="parseInt(fullData.fieldType, 10) === 7">
        <el-date-picker
          v-model="inputValue"
          class="el-select-info"
          :disabled="disabled || fullData.disabled"
          :type="
            parseInt(fullData.timeFormat, 10) === 12
              ? 'year'
              : parseInt(fullData.timeFormat, 10) === 1
              ? 'month'
              : parseInt(fullData.timeFormat, 10) === 8
              ? 'date'
              : 'datetime'
          "
          placeholder="请选择"
        >
        </el-date-picker>
      </div>
      <!-- 附件 -->
      <el-upload
        action=""
        v-if="parseInt(fullData.fieldType, 10) === 9"
        class="avatar-uploader"
        :show-file-list="false"
        :http-request="uploadImage"
        :disabled="disabled || fullData.disabled"
        :before-upload="beforeAvatarUpload"
      >
        <img v-if="imageUrl" :src="imageUrl" class="avatar" alt="" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <!-- 地址选择器 -->
      <div class="el-select-info is-city" v-if="isAddress">
        <div class="select-area">
          <el-select
            v-model="provinceId"
            placeholder="请选择省份"
            @change="changeProvince"
            :disabled="disabled || fullData.disabled"
          >
            <el-option
              v-for="(item, index) in provinceList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
              {{ item.name }}
            </el-option>
          </el-select>
          <el-select
            v-model="cityId"
            :disabled="!provinceId || disabled || fullData.disabled"
            placeholder="请选择城市"
            @change="changeCity"
          >
            <el-option
              v-for="item in cityList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
              {{ item.name }}
            </el-option>
          </el-select>
          <el-select
            v-model="districtId"
            :disabled="!cityId || disabled || fullData.disabled"
            placeholder="请选择区"
            @change="changeDistrict"
          >
            <el-option
              v-for="item in districtList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
              {{ item.name }}
            </el-option>
          </el-select>
        </div>
        <el-input
          :disabled="!districtId || disabled || fullData.disabled"
          v-if="parseInt(fullData.addrRange, 10) === 1"
          class="address"
          v-model="address"
          :placeholder="!districtId ? '请选择完省市区信息' : '请输入详细地址'"
        >
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'childrenComponents',
  props: {
    value: {
      type: [Object, Array, String, Number],
    },
    commondata: Object,
    fullData: {
      type: [Object, Array],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    uploadInfo() {
      return localStorage.getItem('uploadInfo')
        ? JSON.parse(localStorage.getItem('uploadInfo'))
        : null
    },
    isAddress() {
      return parseInt(this.fullData.fieldType, 10) === 29
    },
  },
  data() {
    return {
      provinceId: null,
      provinceName: null,
      cityId: null,
      cityName: null,
      districtId: null,
      districtName: null,
      address: null,
      content: null,
      provinceList: [],
      cityList: [],
      districtList: [],
      showAddress: false,
      imageUrl: null,
      singleId: null,
      singleList: [],
      inputValue: '',
      inputReg: null,
      wasContinue: false,
      needEmit: false,
    }
  },
  methods: {
    /**
     * @description 切换省份
     */
    async changeProvince(res) {
      this.provinceId = res
      this.provinceName = await this.getNameInfo(res, 'province')
      if (parseInt(this.fullData.addrRange, 10) === 4) {
        this.$emit('changeCity', this.fullData, {
          provinceId: this.provinceId,
          provinceName: this.provinceName,
          content: this.provinceName,
        })
      } else {
        this.cityId = null
        this.cityName = null
        this.districtId = null
        this.districtName = null
        this.getCityList()
      }
    },
    /**
     * @description 切换城市
     */
    async changeCity(res) {
      this.cityId = res
      this.cityName = await this.getNameInfo(res, 'city')
      if (parseInt(this.fullData.addrRange, 10) === 3) {
        this.$emit('changeCity', this.fullData, {
          provinceId: this.provinceId,
          provinceName: this.provinceName,
          cityId: this.cityId,
          cityName: this.cityName,
          content: this.provinceName + this.cityName,
        })
      } else {
        this.districtId = null
        this.districtName = null
        this.getDistrictList()
      }
    },
    /**
     * @description 切换区
     */
    async changeDistrict(res) {
      this.districtId = res
      this.districtName = await this.getNameInfo(res, 'district')
      if (parseInt(this.fullData.addrRange, 10) === 2) {
        this.$emit('changeCity', this.fullData, {
          provinceId: this.provinceId,
          provinceName: this.provinceName,
          cityId: this.cityId,
          cityName: this.cityName,
          districtId: this.districtId,
          districtName: this.districtName,
          content: this.provinceName + this.cityName + this.districtName,
        })
      }
    },
    /**
     * @description 获取省市区的名称
     * @param id
     * @param type
     */
    getNameInfo(id, type) {
      let name
      if (type === 'province') {
        this.provinceList.map((item) => {
          if (item.id === id) {
            name = item.name
          }
        })
      } else if (type === 'city') {
        this.cityList.map((item) => {
          if (item.id === id) {
            name = item.name
          }
        })
      } else {
        this.districtList.map((item) => {
          if (item.id === id) {
            name = item.name
          }
        })
      }
      return name
    },
    /**
     * @description 获取省份列表
     * @return {Promise<void>}
     */
    async getProvinceList() {
      let result = await this.$api.post('/mdSearchAddressInfo')
      if (result.isSuccess) {
        this.provinceList = result.data
      } else {
        this.$notify({
          type: 'error',
          title: '获取省份列表失败',
          message: result.msg,
        })
      }
    },
    /**
     * @description 获取城市列表
     * @return {Promise<void>}
     */
    async getCityList() {
      let result = await this.$api.post('/mdSearchAddressInfo', {
        params: {
          parentId: this.provinceId,
        },
      })
      if (result) {
        this.cityList = result.data
      } else {
        this.$notify({
          type: 'error',
          title: '获取市级列表失败',
          message: result.msg,
        })
      }
    },
    /**
     * @description 获取区域列表
     * @return {Promise<void>}
     */
    async getDistrictList() {
      let result = await this.$api.post('/mdSearchAddressInfo', {
        params: {
          parentId: this.cityId,
        },
      })
      if (result.isSuccess) {
        this.districtList = result.data
      } else {
        this.$notify({
          type: 'error',
          title: '获取区级列表失败',
          message: result.msg,
        })
      }
    },
    visibleChange(visible) {
      if (visible) {
        this.getSingleList()
      }
    },
    /**
     * @description 检测图片格式
     * @param file
     * @return {boolean}
     */
    beforeAvatarUpload(file) {
      const typeRight = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!typeRight) {
        this.$message.error('上传图片只能是 JPG / PNG 格式!')
      }
      return typeRight
    },
    /**
     * @description 文件上传
     * @param res
     * @return {Promise<void>}
     */
    async uploadImage(res) {
      let result = await this.$api.post(this.uploadInfo.server, {
        appKey: this.uploadInfo.appKey,
        token: this.uploadInfo.token,
        ts: this.uploadInfo.ts,
        storage_file: res.file,
      })
      if (result.isSuccess) {
        this.imageUrl =
          this.uploadInfo.showImageServer +
          '?token=' +
          this.uploadInfo.showImageToken +
          '&fileCode=' +
          result.data.fileCode +
          '&appKey=' +
          this.uploadInfo.appKey +
          '&ts=' +
          this.uploadInfo.imgTs
        this.$emit('change', this.fullData, {
          type: '000',
          angle: '',
          fileCode: result.data.fileCode,
          code: result.data.fileCode,
          extension: res.file.type.split('/')[1],
          size: res.file.size,
          imageUrl: this.imageUrl,
        })
      } else {
        this.$notify({
          type: 'error',
          title: '上传失败',
          message: result.msg,
        })
      }
    },
    /**
     * @description 切换单选
     * @param res
     */
    changeSingle(res) {
      this.singleList.map((item) => {
        if (res === item.id) {
          this.$emit('change', this.fullData, {
            id: item.id,
            name: item.name,
          })
          this.$emit('changeValue', this.fullData)
        }
      })
    },
    /**
     * @description 获取单选数据清单
     * @return {*}
     */
    async getSingleList() {
      this.isLoading = true
      this.singleList = []
      console.log(this.fullData,'this.fullData');

      const params = this.commondata.getRelationCondition(this.fullData)
      console.log(params,'params');

      const urlPath = params
        ? '/bdQuerySingleRangeFiterListShare'
        : '/mdSearchShareRadio'

        console.log(urlPath,'urlPath');

      let result = await this.$api.post(urlPath, {
        params: {
          field: this.fullData.field,
          uuid: this.fullData.uuid,
          objectTypeId: this.fullData.areaObjTypeId,
          ids: Array.isArray(this.fullData.dataArea) ? this.fullData.dataArea.map((item) => item.id).join(",") : "",
          ...params,
        },
        ...params,
        field: this.fullData.field,
        objectTypeId: this.fullData.areaObjTypeId,
      })
      if (result.isSuccess) {
        this.singleList = params ? result.data : result.data.records
        // if (Array.isArray(this.fullData.dataArea) &&
        // this.fullData.dataArea.length > 0 &&
        // parseInt(this.fullData.dataSource, 10) == 2) {
        //   this.singleList = this.fullData.dataArea;
        // }
        if (params) {
          this.singleList.map((item) => {
            if (!item.name) {
              item.name = item.code
            }
          })
        }
      } else {
        this.$notify({
          type: 'error',
          title: '获取' + this.fullData.name + '的列表数据失败',
          message: result.msg,
        })
      }
      this.isLoading = false
    },
    /**
     * @description 数据检测
     */
    checkValue() {
      if (
        this.inputValue &&
        !/^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(this.inputValue)
      ) {
        this.$notify({
          type: 'error',
          title: '温馨提示',
          message: this.fullData.name + '数据填写有误，请重新填写',
        })
      }
    },
    /**
     * @description 重设数据
     * @param val
     */
    setValue(val) {
      const fieldType = parseInt(this.fullData.fieldType, 10)
      if (fieldType === 5 || fieldType === 9) {
        this.fullData.value = val
        if (fieldType === 5) {
          this.updateSelectValue(val)
        } else {
          this.imageUrl = val[0].imageUrl
        }
      } else {
        this.inputValue = val
      }
    },
    // 更新单选值
    updateSelectValue(val) {
      var id = null
      var name = ""
      if (Array.isArray(val) && val.length > 0) {
        id = val[0].id
        name = val[0].name
      }
      this.singleId = id;
      setTimeout(() => {
        this.$refs.select.$children[0].$refs.input.value = name ? name : ""
      }, 100);
    },
    async updateAddressValue() {
      if (this.fullData.mdValue) {
        var value = this.fullData.mdValue
        this.provinceName = value.provinceName
        this.provinceId = value.provinceId
        this.cityName = value.cityName
        this.cityId = value.cityId
        this.districtId = value.districtId
        this.districtName = value.districtName
        this.address = value.address
        await this.getProvinceList()
        await this.getCityList()
        await this.getDistrictList()
      } else {
        this.getProvinceList()
      }
    },
  },
  created() {
    const fieldType = parseInt(this.fullData.fieldType, 10)
    if (fieldType < 9 && this.fullData.value) {
      this.inputValue = this.fullData.value
    }
    this.fullData._setValue = (val) => {
      this.setValue(val)
    }

    if (parseInt(this.fullData.fieldType, 10) === 5) {
      if (this.fullData.defaults) {
        const vals = JSON.parse(this.fullData.defaults)
        if (Array.isArray(vals)) {
          this.updateSelectValue(vals)
        }
      }
    }
    if (this.fullData.mdValue && !this.isAddress) {
      this.setValue(this.fullData.mdValue)
    }
    if (parseInt(this.fullData.fieldType, 10) === 29) {
      this.updateAddressValue()
    }
    this.$nextTick(() => {
      this.needEmit = true
    })
  },
  watch: {
    value(nVal) {
      this.setValue(nVal)
    },
    address() {
      this.$emit('changeCity', this.fullData, {
        provinceId: this.provinceId,
        provinceName: this.provinceName,
        cityId: this.cityId,
        cityName: this.cityName,
        districtId: this.districtId,
        districtName: this.districtName,
        content:
          this.provinceName + this.cityName + this.districtName + this.address,
        address: this.address,
      })
    },
    inputValue() {
      if (!this.needEmit) {
        return
      }
      if (this.inputValue) {
        if (
          parseInt(this.fullData.fieldType, 10) === 1 ||
          parseInt(this.fullData.fieldType, 10) === 2 ||
          parseInt(this.fullData.fieldType, 10) === 3 ||
          parseInt(this.fullData.fieldType, 10) === 4
        ) {
          this.$emit('input', this.inputValue)
          this.$emit('changeValue', this.fullData)
        } else {
          let type = parseInt(this.fullData.timeFormat)
          let dateInfo = new Date(this.inputValue)
          let month =
            dateInfo.getMonth() + 1 > 9
              ? dateInfo.getMonth() + 1
              : '0' + (dateInfo.getMonth() + 1)
          let year = dateInfo.getFullYear()
          let date =
            dateInfo.getDate() > 9
              ? dateInfo.getDate()
              : '0' + dateInfo.getDate()
          let hours =
            dateInfo.getHours() > 9
              ? dateInfo.getHours()
              : '0' + dateInfo.getHours()
          let minutes =
            dateInfo.getMinutes() > 9
              ? dateInfo.getMinutes()
              : '0' + dateInfo.getMinutes()
          let val
          if (type === 1) {
            val = year + '-' + month + '-01 00:00:00'
          }
          if (type === 12) {
            val = year + '-01-01 00:00:00'
          }
          if (type === 8) {
            val = year + '-' + month + '-' + date + ' 00:00:00'
          }
          if (type === 9) {
            val =
              year +
              '-' +
              month +
              '-' +
              date +
              ' ' +
              hours +
              ':' +
              minutes +
              ':00'
          }
          this.$emit('input', val)
          this.$emit('changeValue', this.fullData)
        }
      } else {
        this.$emit('input', null)
        this.$emit('changeValue', this.fullData)
      }
    },
  },
}
</script>

<style lang="scss">
</style>
